import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { GetChronologyRes } from '@/api/types/queries';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetChronologyFacts = ({
  chronologyId,
  caseId,
  pageIndex,
  pageSize,
  paginated = true,
}: {
  chronologyId: string;
  caseId: string;
  pageIndex: number;
  pageSize: number;
  paginated?: boolean;
}) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<GetChronologyRes>(
    [QueryEntity.ChronologyFacts, { chronologyId }, { pageIndex, pageSize, paginated }],
    () => {
      const params = new URLSearchParams();

      if (paginated) {
        params.append('page', String(pageIndex + 1));
        params.append('pageSize', String(pageSize));
      }

      params.append('paginated', String(paginated));

      return fetch(
        `${APIBaseChronos}/api/case/${caseId}/chronology/${chronologyId}/facts?${params.toString()}`,
        fetchConfigGET,
      ).then(async (res) => {
        return await res.json();
      });
    },
    {
      enabled: !!chronologyId && !!caseId,
    },
  );
};
